const guard = (to, from, next) => {
  if (from.name) window.dtPageName = from.name;
  next();
};

export default guard;
